import {useState} from "react";
import {FinalGeneralInfoItem, GeneralInfoItem} from "../types/generalInfo";
import {openSuccessNotification, showErrorNotification} from "../helpers/mainHelpers";
import {generalInfoService} from "../services/generalInfo-service";
import {useForm} from "antd/es/form/Form";
import {Modal} from "antd";
import {DeleteOutlined} from "@ant-design/icons";

export const useGeneralInfoController = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [lastUpdate, setLastUpdate] = useState(0)
  const [generalInfoItemsList, setGeneralInfoItemsList] = useState<FinalGeneralInfoItem[]>([])
  const [selectedGeneralInfoItem, setSelectedGeneralInfoItem] = useState<FinalGeneralInfoItem | undefined>(undefined)
  const [form] = useForm()

  const toggleModal = () => {
    const newValue = !isModalOpen
    setIsModalOpen(newValue)
    if (newValue === false) {
      form.resetFields()
      setSelectedGeneralInfoItem(undefined)
    }
  }

  const toggleLastUpdate = () => {
    setLastUpdate(Date.now)
  }

  const fetchGeneralInfoItemsList = async (queries: string[]) => {
    setIsLoading(true)
    try {
      const list = await generalInfoService.list(queries)
      setGeneralInfoItemsList(list)
    } catch (error) {
      console.error(error)
      showErrorNotification({message: "Помилка при отриманні записів!"})
    } finally {
      setIsLoading(false)
    }
  }
  const createGeneralInfoItem = async (data: FinalGeneralInfoItem) => {
    setIsLoading(true)
    try {
      await generalInfoService.create(data)
      openSuccessNotification("Інформацію для громадян успішно додано!")
      toggleModal()
      toggleLastUpdate()
    } catch (error) {
      showErrorNotification({
        message: "Помилка при додаванні інформації для громадян!",
        description: JSON.stringify(error)
      })
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  const updateGeneralInfoItem = async (data: GeneralInfoItem) => {
    setIsLoading(true)
    try {
      await generalInfoService.update({$id: selectedGeneralInfoItem?.$id, ...data})
      toggleModal()
      toggleLastUpdate()
      openSuccessNotification("Інформацію для громадян успішно оновлено!")
    } catch (error) {
      console.error(error)
      showErrorNotification({
        message: "Помилка при оновленні інформації для громадян!",
        description: JSON.stringify(error)
      })
    } finally {
      setIsLoading(false)
    }
  }

  const getGeneralInfoItemData = async (id: string) => {
    setIsLoading(true)
    try {
      const data = await generalInfoService.getById(id)
      setSelectedGeneralInfoItem(data)
    } catch (error) {
      console.error(error)
      showErrorNotification({message: "Помилка при завантаженні інформації!"})
    } finally {
      setIsLoading(false)
    }
  }

  const confirmDelete = (props: { id: string }) => {
    const {confirm} = Modal;
    confirm(
      {
        width: 400,
        icon: <DeleteOutlined/>,
        title: `Видалити запис?`,
        okText: "Видалити",
        okButtonProps: {danger: true},
        cancelText: "Cкасувати",
        onOk: async () => {
          await deleteGeneralInfoItem(props.id)
        },
      });
  }

  const deleteGeneralInfoItem = async (id: string) => {
    setIsLoading(true)
    try {
      await generalInfoService.delete(id)
      const updatedList = generalInfoItemsList.filter(item => item.$id !== id)
      setGeneralInfoItemsList(updatedList)
      openSuccessNotification("Запис успішно видалено!")
    } catch (error) {
      console.error(error)
      showErrorNotification({message: "Помилка видалення запису!", description: JSON.stringify(error)});
    } finally {
      setIsLoading(false)
    }
  }


  const submitButtonHandler = async (formData: { title: string, category?: string, link: string , isFileLink: boolean}) => {
    if (selectedGeneralInfoItem) {
      // await updateGeneralInfoItem(formData)
    } else {
      await createGeneralInfoItem(formData)
    }
  }

  const editButtonHandler = (item: FinalGeneralInfoItem) => {
    showErrorNotification({
      message: "Оновлення в процесі розробки!",
    })
    // setSelectedGeneralInfoItem(item)
    // toggleModal()
  }


  return {
    isLoading,
    isModalOpen,
    lastUpdate,
    generalInfoItemsList,
    fetchGeneralInfoItemsList,
    selectedGeneralInfoItem,
    form,
    submitButtonHandler,
    toggleModal,
    editButtonHandler,
    confirmDelete,
    getGeneralInfoItemData
  }
}

export default useGeneralInfoController